import React, { useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import '../styles/Home.css';
import BaseLayout from './BaseLayout';

const Home = () => {
  const { username, isAuthenticated, logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/login');
    }
  }, [isAuthenticated, navigate]);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  console.log('Current username in Home:', username); // Debug log

  return (
    <BaseLayout>
      <div className="home-container">
        <h1 className="home-header">
          Welcome, {username || 'lets get to work'}!
        </h1>
        
        <div className="feature-grid">
          {/* Exercise Database Card */}
          <div className="feature-card">
            <h2>Exercise Database</h2>
            <p>Browse our comprehensive database of exercises.</p>
            <Link to="/exercises" className="feature-link">
              View Exercises
            </Link>
          </div>

          {/* Program Designer Card */}
          <div className="feature-card">
            <h2>Training Program</h2>
            <p>Create and manage your training programs.</p>
            <Link to="/create-program" className="feature-link">
              Design Program
            </Link>
          </div>

          {/* Account Management Card */}
          <div className="feature-card">
            <h2>Account</h2>
            <p>Manage your account settings and preferences.</p>
            <button onClick={handleLogout} className="logout-button">
              Log Out
            </button>
          </div>
        </div>
      </div>
    </BaseLayout>
  );
};

export default Home;